import { Icon } from "@iconify/react/dist/iconify.js";
import useStyles from "../styles";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ApplicantExaminationCard = ({ examtitle, examdesc, duration, examlink }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.cardcont} text-align-left`}>
      <div className="flex-start justify-items-space">
        <div>
          <h3>{examtitle}</h3>
          <p>{examdesc}</p>
        </div>
        <div className={`${classes.durationcont} flex gap-5 align-items-start`}>
          <Icon icon="iconamoon:clock-fill" width="18" height="18" style={{ color: "#0065FF" }} />
          <p>{duration}</p>
        </div>
      </div>
      <div>
        <div className={classes.itembottom}>
          <Link className={classes.examlink} to={examlink}>Start Exam</Link>
        </div>
        {/* <div className="flex gap-10 justifyRight">
          <img src={Timer} alt="" />
          <p>{duration}</p>
        </div> */}
      </div>
    </div>
  );
};
ApplicantExaminationCard.PropTypes = {
  examlink: PropTypes.string,
  examtitle: PropTypes.string,
  examdesc: PropTypes.string,
  duration: PropTypes.string
};

export default ApplicantExaminationCard;
